module.exports = __webpack_public_path__ + "media/border-radio.19779936.mp4";